import { ButtonPress } from "./Button/ButtonPress";
import { Text } from "./Text";

export function PanelBackHeading({
  title,
  backLabel,
  onBack,
}: {
  title: string;
  backLabel: string;
  onBack: () => void;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        flex: 1,
        minWidth: 0,
        marginRight: 8,
      }}
    >
      <ButtonPress
        variant="secondary"
        icon="arrow-left"
        aria-label={backLabel}
        onPress={onBack}
      />
      <Text variant="text-small-md" ellipsis>
        {title}
      </Text>
    </div>
  );
}
